import { AdyenHandler, IAdyenStyle, IInitCtx } from '@/lib/PaymentMethods';
import Payments, { AdyenPayment, IAdyenConfig } from '@reolink-web/payment-sdk';

type PaymentsInstance = InstanceType<typeof Payments>;

export type UIElement = Parameters<
    NonNullable<Parameters<PaymentsInstance['createAdyen']>[0]['onSubmit']>
>[1];

/**
 * adyen支付实例工厂
 * 由于支付、签约等功能均需要使用adyen实例，故将adyen实例的创建封装在此处。
 * 请勿在此处加入业务逻辑
 * adyenStyle的值可能与业务有关，由业务层维护
 */
export async function createAdyenInstance(
    adyenAccountConfig: Omit<IAdyenConfig, 'locale' | 'analytics'> &
        Required<Pick<IAdyenConfig, 'clientKey' | 'environment' | 'paymentMethodsResponse'>>,
    adyenStyle: IAdyenStyle,
    options: {
        orderId?: string;
        subscriptionId?: string;
        onSuccess: IInitCtx['handleSuccess'];
        onError?: IInitCtx['onError'];
        showDefaultError?: IInitCtx['showDefaultError'];
        onAction?: IInitCtx['onAction'];
        onAdditionalDetails?: IAdyenConfig['onAdditionalDetails'];
    }
): Promise<AdyenPayment | undefined>  {
    
    const paymentInstall = new Payments();

    const adyenHandler = new AdyenHandler( paymentInstall );

    paymentInstall.init({
        configuration: {
            sort: ['adyen'],
            adyen: {
                clientKey: adyenAccountConfig.clientKey,
                region: adyenAccountConfig.environment,
                enabled: true,
                paymentMethods: adyenAccountConfig.paymentMethodsResponse.paymentMethods ?? []
            }
        }
    });

    await adyenHandler.init({
        subscriptionId: options.subscriptionId,
        orderId: options.orderId,
        cfg: adyenStyle,
        handleSuccess: options.onSuccess,
        onError: options.onError,
        showDefaultError: options.showDefaultError,
        onAction: options.onAction,
        onAdditionalDetails: options.onAdditionalDetails
    });

    const adyenInstance = adyenHandler.getInstance() ?? undefined;

    return adyenInstance;

}
